import { render } from "./OrderFormContainer.vue?vue&type=template&id=3c42d554&scoped=true&ts=true"
import script from "./OrderFormContainer.vue?vue&type=script&lang=ts"
export * from "./OrderFormContainer.vue?vue&type=script&lang=ts"

import "./OrderFormContainer.vue?vue&type=style&index=0&id=3c42d554&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c42d554"]])

export default __exports__